import { render } from "./ExternalDynamicForm.vue?vue&type=template&id=0e5e24b1&scoped=true"
import script from "./ExternalDynamicForm.vue?vue&type=script&lang=js"
export * from "./ExternalDynamicForm.vue?vue&type=script&lang=js"

import "./ExternalDynamicForm.vue?vue&type=style&index=0&id=0e5e24b1&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e5e24b1"]])

export default __exports__
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBanner from 'quasar/src/components/banner/QBanner.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInnerLoading,QCard,QIcon,QBanner});
